module.exports = __webpack_public_path__ + "1a4bcb3ec9c508d478d4dbf6b56f6208.woff2";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Bold.woff2
// module id = 350
// module chunks = 0